<!-- eslint-disable-next-line vue/valid-template-root -->
<template> </template>

<script setup lang="ts">
/**
 * ### 隐藏字段
 * 用以发送一些页面常量信息给后端
 * <warning> 由于该组件未设置set方法 所以通过修改参数方法修改该组件值不会生效 需通过ref来动态修改该组件value
 * <warning> 如若同时修改多个该组件的value因为渲染原因只会有一个生效 此时需将每个修改放入到异步队列中
 */
import { watch } from 'vue';
import { useShareData } from '../../../core/SharedData';

const props = defineProps<{
  /**
   * ### 字段key
   */
  name: string;
  /**
   * ### 向后端提交的值
   */
  value: any;
  /**
   * ### 值变化时是否自动执行查询
   */
  autoSearch?: boolean;
  /**
   * ### 这个属性没用, 用来SearchCondition中通过该属性判断是否有UI
   */
  noUi?: boolean;
}>();

const setParam = useShareData('search', 'params').$(props.name);
setParam(props.value);

if (props.autoSearch) {
  const submit = useShareData('search', 'submit');

  watch(
    () => props.value,
    (newValue) => {
      setParam(newValue);

      submit();
    }
  );
}
</script>
